// Ledger rows that exist ONLY in the DM ledger (relay PG), never in the session timeline, so
// "older than the floor means already rendered" is false for them and they must still merge:
// a structured card (MEM-UI-009) and the daemon's notices (`sysn_` id: oversize-image, busy refusal,
// goal-clear line; posted BEFORE or between replies, so their seq sits below the floor), and a
// message that is only files (an agent's cyborg7_send_message with an image and no words).
const PRE_SYSN_HANDOFF_PAUSE_ID = "agent-hop-handoff-";
export function survivesLedgerFloor(m: {
  id: string;
  card?: unknown;
  text?: string;
  attachments?: readonly unknown[] | null; // null: a row stored with no files
}): boolean {
  if (m.card || m.id.startsWith("sysn_") || m.id.startsWith(PRE_SYSN_HANDOFF_PAUSE_ID)) return true;
  return !m.text?.trim() && !!m.attachments?.length;
}

// The daemon's "did not run" line is stored as `sysn_refused_<sha256(workspace, sender, clientMsgId)>`
// (server busy-refusal.ts refusedNoticeId). Its presence is the ONLY proof that the human row never
// became a turn; "no timeline twin" is not proof (the twin can land seconds, or minutes, later).
export async function refusedNoticeId(
  workspaceId: string,
  userId: string,
  promptId: string,
): Promise<string> {
  const scope = new TextEncoder().encode(JSON.stringify([workspaceId, userId, promptId]));
  const digest = new Uint8Array(await globalThis.crypto.subtle.digest("SHA-256", scope));
  const hex = Array.from(digest, (b) => b.toString(16).padStart(2, "0")).join("");
  return `sysn_refused_${hex.slice(0, 32)}`;
}

// The ids of the viewer's rows whose refusal line is among `rows`.
export async function refusedHumanRows(
  workspaceId: string,
  humans: Iterable<{ id: string; fromId: string; clientMsgId?: string | null }>,
  rows: Iterable<{ id: string }>,
): Promise<Set<string>> {
  const lines = new Set(Array.from(rows, (r) => r.id));
  const out = new Set<string>();
  for (const h of humans) {
    if (h.clientMsgId && lines.has(await refusedNoticeId(workspaceId, h.fromId, h.clientMsgId))) {
      out.add(h.id);
    }
  }
  return out;
}
